import { type FC, type PropsWithChildren } from "react";
import { Box, CircularProgress, Zoom } from "@mui/material";
import { SignIn } from "@/admin/features/auth/";
import { useCurrentUserQuery, useSignOut } from "@/admin/entities/auth";
import { AuthProvider as AuthClientProvider } from "@/admin/entities/auth";
import { AccessDenied } from "@/admin/shared/ui";
import { ErrorMessage } from "@/shared/components";

export const AuthProvider: FC<PropsWithChildren> = ({ children }) => {
  const [signOut, { loading: signOutLoading }] = useSignOut();
  const { data, loading, error } = useCurrentUserQuery();
  const currentUser = data?.currentUser;

  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <Zoom in>
          <CircularProgress size={100} />
        </Zoom>
      </Box>
    );
  }

  if (error) {
    return <ErrorMessage error={error} />;
  }

  if (!currentUser) return <SignIn />;

  if (!currentUser.isAdmin && !currentUser.isSuperAdmin)
    return <AccessDenied onSignOut={signOut} loading={signOutLoading} />;

  return <AuthClientProvider user={currentUser}>{children}</AuthClientProvider>;
};
